/*
 * Single Blog article
 *
 */

import 'lightbox2';

export default class blogArtilce {
    constructor() {
        // console.info('Blog Article');
        this.buildLightboxGallery();
        this.initListeners();
    }

    buildLightboxGallery() {
        $('.layout-module_wysiwyg img').each((i, el) => {
            const src = $(el).attr('src');
            $(el).wrap(`<a href="${src}" data-lightbox="gallery"></a>`);
        });
    }

    initListeners() {}
}
